export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  DateTime: any;
  Decimal: any;
  Guid: any;
  UInt: any;
  ULong: any;
  Upload: any;
};

/** Queries for Archive */
export type ArchiveQueries = {
  __typename?: "ArchiveQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Archive>;
  getByID?: Maybe<CommandResult_Archive>;
};

/** Queries for Archive */
export type ArchiveQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Archive */
export type ArchiveQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ArchiveType = {
  __typename?: "ArchiveType";
  /** The creation date of the Archive */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Archive */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Archive */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the archive */
  description?: Maybe<Scalars["String"]>;
  /** The extension of the archive */
  extension: Scalars["String"];
  /** The external id of the archive */
  externalId: Scalars["String"];
  /** The id of the Archive */
  id: Scalars["ID"];
  /** The original name of the archive */
  originalName: Scalars["String"];
  /** The storage name of the archive */
  storageName: Scalars["String"];
  /** The storage url of the archive */
  storageUrl: Scalars["String"];
  /** The update date of the Archive */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** AssetsMutation for the Topcon Customer GraphQL API */
export type AssetsMutation = {
  __typename?: "AssetsMutation";
  uploadIcons?: Maybe<CommandResult_Void>;
};

/** AssetsMutation for the Topcon Customer GraphQL API */
export type AssetsMutationUploadIconsArgs = {
  favicon?: InputMaybe<Scalars["Upload"]>;
  logo?: InputMaybe<Scalars["Upload"]>;
  logo192?: InputMaybe<Scalars["Upload"]>;
  logotipo?: InputMaybe<Scalars["Upload"]>;
  logotipoMinifiedColor?: InputMaybe<Scalars["Upload"]>;
  logotipoMinifiedWhite?: InputMaybe<Scalars["Upload"]>;
};

/** Mutations for Client */
export type ClientMutations = {
  __typename?: "ClientMutations";
  update?: Maybe<CommandResult_Client>;
};

/** Mutations for Client */
export type ClientMutationsUpdateArgs = {
  client: ClientUpdateInputType;
};

/** Queries for Client */
export type ClientQueries = {
  __typename?: "ClientQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Client>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Client>;
  getAllWithoutPagination?: Maybe<EnumerableCommandResult_Client>;
  getByID?: Maybe<CommandResult_Client>;
};

/** Queries for Client */
export type ClientQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Client */
export type ClientQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Client */
export type ClientQueriesGetAllWithoutPaginationArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Client */
export type ClientQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ClientType = {
  __typename?: "ClientType";
  /** The alias of the client */
  alias: Scalars["String"];
  /** The constructions of the client */
  constructions?: Maybe<Array<Maybe<ConstructionType>>>;
  /** The creation date of the Client */
  createdAt: Scalars["DateTime"];
  /** The credit limit of the client */
  creditLimit?: Maybe<Scalars["Decimal"]>;
  /** The credit limit expiration of the client */
  creditLimitExpiration?: Maybe<Scalars["DateTime"]>;
  /** The credit limit used of the client */
  creditLimitUsed?: Maybe<Scalars["Decimal"]>;
  /** The deleted status of the Client */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Client */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The document number of the client */
  document: Scalars["String"];
  /** The external id of the client */
  externalId: Scalars["String"];
  /** The id of the Client */
  id: Scalars["ID"];
  /** The name of the client */
  name: Scalars["String"];
  /** The pendency of the client */
  pendency?: Maybe<Scalars["String"]>;
  /** The update date of the Client */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Client Update Input */
export type ClientUpdateInputType = {
  /** The credit limit of the client */
  creditLimit?: InputMaybe<Scalars["Decimal"]>;
  /** The credit limit used of the client */
  creditLimitUsed?: InputMaybe<Scalars["Decimal"]>;
  /** The id of the Client */
  id: Scalars["ID"];
};

/** The result of a command */
export type CommandResult_Archive = {
  __typename?: "CommandResult_Archive";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ArchiveType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Client = {
  __typename?: "CommandResult_Client";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ClientType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcreteBatchingPlant = {
  __typename?: "CommandResult_ConcreteBatchingPlant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcreteBatchingPlantType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcreteMixer = {
  __typename?: "CommandResult_ConcreteMixer";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcreteMixerType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcreteRecipe = {
  __typename?: "CommandResult_ConcreteRecipe";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcreteRecipeType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcreteStrengthCertificate = {
  __typename?: "CommandResult_ConcreteStrengthCertificate";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcreteStrengthCertificateType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Concreting = {
  __typename?: "CommandResult_Concreting";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcretingType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcretingRequest = {
  __typename?: "CommandResult_ConcretingRequest";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcretingRequestType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConcretingRequestMessage = {
  __typename?: "CommandResult_ConcretingRequestMessage";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConcretingRequestMessageType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Construction = {
  __typename?: "CommandResult_Construction";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConstructionType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ConstructionEmail = {
  __typename?: "CommandResult_ConstructionEmail";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ConstructionEmailType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Contract = {
  __typename?: "CommandResult_Contract";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ContractType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ContractConcreteBatchingPlant = {
  __typename?: "CommandResult_ContractConcreteBatchingPlant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ContractConcreteBatchingPlantType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ContractConcreteRecipe = {
  __typename?: "CommandResult_ContractConcreteRecipe";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ContractConcreteRecipeType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ContractPumpType = {
  __typename?: "CommandResult_ContractPumpType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ContractPumpTypeType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ContractSeller = {
  __typename?: "CommandResult_ContractSeller";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ContractSellerType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Driver = {
  __typename?: "CommandResult_Driver";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<DriverType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_FiscalDocument = {
  __typename?: "CommandResult_FiscalDocument";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<FiscalDocumentType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_GravelType = {
  __typename?: "CommandResult_GravelType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<GravelTypeType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Invoice = {
  __typename?: "CommandResult_Invoice";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<InvoiceType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_InvoiceInstallment = {
  __typename?: "CommandResult_InvoiceInstallment";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<InvoiceInstallmentType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Module = {
  __typename?: "CommandResult_Module";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ModuleType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Param = {
  __typename?: "CommandResult_Param";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ParamType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_PermissionUser = {
  __typename?: "CommandResult_PermissionUser";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<PermissionUserType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_ResistanceType = {
  __typename?: "CommandResult_ResistanceType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<ResistanceTypeType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Seller = {
  __typename?: "CommandResult_Seller";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<SellerType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_SellerModule = {
  __typename?: "CommandResult_SellerModule";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<SellerModuleType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Travel = {
  __typename?: "CommandResult_Travel";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<TravelType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_User = {
  __typename?: "CommandResult_User";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<UserType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_VehiclePosition = {
  __typename?: "CommandResult_VehiclePosition";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<VehiclePositionType>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command */
export type CommandResult_Void = {
  __typename?: "CommandResult_Void";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** Queries for ConcreteBatchingPlant */
export type ConcreteBatchingPlantQueries = {
  __typename?: "ConcreteBatchingPlantQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcreteBatchingPlant>;
  getByID?: Maybe<CommandResult_ConcreteBatchingPlant>;
};

/** Queries for ConcreteBatchingPlant */
export type ConcreteBatchingPlantQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcreteBatchingPlant */
export type ConcreteBatchingPlantQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcreteBatchingPlantType = {
  __typename?: "ConcreteBatchingPlantType";
  /** The abbreviation of the concreteBatchingPlant */
  abbreviation: Scalars["String"];
  /** The code of the concreteBatchingPlant */
  code: Scalars["String"];
  /** The concretings of the concreteBatchingPlant */
  concretings?: Maybe<Array<Maybe<ConcretingType>>>;
  /** The creation date of the ConcreteBatchingPlant */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcreteBatchingPlant */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcreteBatchingPlant */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The external id of the concreteBatchingPlant */
  externalId: Scalars["String"];
  /** The id of the ConcreteBatchingPlant */
  id: Scalars["ID"];
  /** The name of the concreteBatchingPlant */
  name: Scalars["String"];
  /** The update date of the ConcreteBatchingPlant */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ConcreteMixer */
export type ConcreteMixerQueries = {
  __typename?: "ConcreteMixerQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcreteMixer>;
  getByID?: Maybe<CommandResult_ConcreteMixer>;
};

/** Queries for ConcreteMixer */
export type ConcreteMixerQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcreteMixer */
export type ConcreteMixerQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcreteMixerType = {
  __typename?: "ConcreteMixerType";
  /** The code of the concreteMixer */
  code: Scalars["String"];
  /** The creation date of the ConcreteMixer */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcreteMixer */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcreteMixer */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the concreteMixer */
  description: Scalars["String"];
  /** The external id of the concreteMixer */
  externalId: Scalars["String"];
  /** The id of the ConcreteMixer */
  id: Scalars["ID"];
  /** The license plate of the concreteMixer */
  licensePlate: Scalars["String"];
  /** The travels of the concreteMixer */
  travels?: Maybe<Array<Maybe<TravelType>>>;
  /** The update date of the ConcreteMixer */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ConcreteRecipe */
export type ConcreteRecipeQueries = {
  __typename?: "ConcreteRecipeQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcreteRecipe>;
  getByID?: Maybe<CommandResult_ConcreteRecipe>;
};

/** Queries for ConcreteRecipe */
export type ConcreteRecipeQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcreteRecipe */
export type ConcreteRecipeQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcreteRecipeType = {
  __typename?: "ConcreteRecipeType";
  /** The application of the concreteRecipe */
  application?: Maybe<Scalars["String"]>;
  /** The contract concreteRecipes of the concreteRecipe */
  contractConcreteRecipes?: Maybe<Array<Maybe<ContractConcreteRecipeType>>>;
  /** The creation date of the ConcreteRecipe */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcreteRecipe */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcreteRecipe */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the concreteRecipe */
  description: Scalars["String"];
  /** The external id of the concreteRecipe */
  externalId: Scalars["String"];
  /** The gravel type of the concreteRecipe */
  gravelType?: Maybe<GravelTypeType>;
  /** The id of the ConcreteRecipe */
  id: Scalars["ID"];
  /** The resistance of the concreteRecipe */
  resistance?: Maybe<Scalars["String"]>;
  /** The resistance complement of the concreteRecipe */
  resistanceComplement?: Maybe<Scalars["String"]>;
  /** The resistance type of the concreteRecipe */
  resistanceType?: Maybe<ResistanceTypeType>;
  /** The slump of the concreteRecipe */
  slump?: Maybe<Scalars["Decimal"]>;
  /** The slump type of the concreteRecipe */
  slumpType?: Maybe<ESlumpTypes | `${ESlumpTypes}`>;
  /** The update date of the ConcreteRecipe */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ConcreteStrengthCertificate */
export type ConcreteStrengthCertificateQueries = {
  __typename?: "ConcreteStrengthCertificateQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcreteStrengthCertificate>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_ConcreteStrengthCertificate>;
  getByID?: Maybe<CommandResult_ConcreteStrengthCertificate>;
};

/** Queries for ConcreteStrengthCertificate */
export type ConcreteStrengthCertificateQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcreteStrengthCertificate */
export type ConcreteStrengthCertificateQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcreteStrengthCertificate */
export type ConcreteStrengthCertificateQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcreteStrengthCertificateType = {
  __typename?: "ConcreteStrengthCertificateType";
  /** The archive of the concreteStrengthCertificate */
  archive?: Maybe<ArchiveType>;
  /** The concreting of the concreteStrengthCertificate */
  concreting?: Maybe<ConcretingType>;
  /** The creation date of the ConcreteStrengthCertificate */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcreteStrengthCertificate */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcreteStrengthCertificate */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the concreteStrengthCertificate */
  description: Scalars["String"];
  /** The external id of the concreteStrengthCertificate */
  externalId: Scalars["String"];
  /** The id of the ConcreteStrengthCertificate */
  id: Scalars["ID"];
  /** The issue date of the concreteStrengthCertificate */
  issueDate: Scalars["DateTime"];
  /** The update date of the ConcreteStrengthCertificate */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for Concreting */
export type ConcretingQueries = {
  __typename?: "ConcretingQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Concreting>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Concreting>;
  getByID?: Maybe<CommandResult_Concreting>;
};

/** Queries for Concreting */
export type ConcretingQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Concreting */
export type ConcretingQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Concreting */
export type ConcretingQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

/** ConcretingRequest Create Input */
export type ConcretingRequestCreateInputType = {
  /** The concrete batching plant id of the concreting request */
  concreteBatchingPlantId?: InputMaybe<Scalars["ID"]>;
  /** The contract concrete recipe id of the concreting request */
  contractConcreteRecipeId: Scalars["ID"];
  /** The contract id of the concreting request */
  contractId: Scalars["ID"];
  /** The contract pump type id of the concreting request */
  contractPumpTypeId?: InputMaybe<Scalars["ID"]>;
  /** The interval of the concreting request */
  interval?: InputMaybe<Scalars["String"]>;
  /** The observation concreting of the concreting request */
  observationConcreting?: InputMaybe<Scalars["String"]>;
  /** The observation pump of the concreting request */
  observationPump?: InputMaybe<Scalars["String"]>;
  /** The piece to be concreted of the concreting request */
  pieceToBeConcreted?: InputMaybe<Scalars["String"]>;
  /** The piping distance of the pump of the concreting request */
  pipingDistance: Scalars["Decimal"];
  /** The pump of the concreting request */
  pump: EConcretingRequestPump | `${EConcretingRequestPump}`;
  /** The quantity per concrete mixer of the concreting request */
  quantityPerConcreteMixer: Scalars["Decimal"];
  /** The requested date of the concreting request */
  requestedDate: Scalars["DateTime"];
  /** The requested quantity of the concreting request */
  requestedQuantity: Scalars["Decimal"];
  /** The requester of the concreting request */
  requester: Scalars["String"];
  /** The requester phone number of the concreting request */
  requesterPhoneNumber: Scalars["String"];
  /** The requesting user id of the concreting request */
  requestingUserId: Scalars["ID"];
  /** The travels released of the concreting request */
  travelsReleased?: InputMaybe<Scalars["Int"]>;
};

/** ConcretingRequestMessage Create Input */
export type ConcretingRequestMessageCreateInputType = {
  /** The concreting request id of the concreting request message */
  concretingRequestId: Scalars["ID"];
  /** The message */
  message: Scalars["String"];
  /** The user id of the concreting request message */
  userId: Scalars["ID"];
};

/** Mutations for ConcretingRequestMessage */
export type ConcretingRequestMessageMutations = {
  __typename?: "ConcretingRequestMessageMutations";
  create?: Maybe<CommandResult_ConcretingRequestMessage>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_ConcretingRequestMessage>;
};

/** Mutations for ConcretingRequestMessage */
export type ConcretingRequestMessageMutationsCreateArgs = {
  concretingRequestMessage: ConcretingRequestMessageCreateInputType;
};

/** Mutations for ConcretingRequestMessage */
export type ConcretingRequestMessageMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for ConcretingRequestMessage */
export type ConcretingRequestMessageMutationsUpdateArgs = {
  concretingRequestMessage: ConcretingRequestMessageUpdateInputType;
};

/** Queries for ConcretingRequestMessage */
export type ConcretingRequestMessageQueries = {
  __typename?: "ConcretingRequestMessageQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcretingRequestMessage>;
  getByID?: Maybe<CommandResult_ConcretingRequestMessage>;
};

/** Queries for ConcretingRequestMessage */
export type ConcretingRequestMessageQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcretingRequestMessage */
export type ConcretingRequestMessageQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcretingRequestMessageType = {
  __typename?: "ConcretingRequestMessageType";
  /** The concreting request of the message */
  concretingRequest?: Maybe<ConcretingRequestType>;
  /** The creation date of the ConcretingRequestMessage */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcretingRequestMessage */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcretingRequestMessage */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the ConcretingRequestMessage */
  id: Scalars["ID"];
  /** The message */
  message: Scalars["String"];
  /** The update date of the ConcretingRequestMessage */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The user who sent the message */
  user?: Maybe<UserType>;
};

/** ConcretingRequestMessage Update Input */
export type ConcretingRequestMessageUpdateInputType = {
  /** The concreting request id of the concreting request message */
  concretingRequestId: Scalars["ID"];
  /** The id of the ConcretingRequestMessage */
  id: Scalars["ID"];
  /** The message */
  message: Scalars["String"];
  /** The user id of the concreting request message */
  userId: Scalars["ID"];
};

/** Mutations for ConcretingRequest */
export type ConcretingRequestMutations = {
  __typename?: "ConcretingRequestMutations";
  concretingRequestUpdateStatus?: Maybe<CommandResult_ConcretingRequest>;
  create?: Maybe<CommandResult_ConcretingRequest>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_ConcretingRequest>;
};

/** Mutations for ConcretingRequest */
export type ConcretingRequestMutationsConcretingRequestUpdateStatusArgs = {
  concretingRequestStatus: ConcretingRequestUpdateStatusInputType;
};

/** Mutations for ConcretingRequest */
export type ConcretingRequestMutationsCreateArgs = {
  concretingRequest: ConcretingRequestCreateInputType;
};

/** Mutations for ConcretingRequest */
export type ConcretingRequestMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for ConcretingRequest */
export type ConcretingRequestMutationsUpdateArgs = {
  concretingRequest: ConcretingRequestUpdateInputType;
};

/** Queries for ConcretingRequest */
export type ConcretingRequestQueries = {
  __typename?: "ConcretingRequestQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConcretingRequest>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_ConcretingRequest>;
  getByID?: Maybe<CommandResult_ConcretingRequest>;
};

/** Queries for ConcretingRequest */
export type ConcretingRequestQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcretingRequest */
export type ConcretingRequestQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConcretingRequest */
export type ConcretingRequestQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConcretingRequestType = {
  __typename?: "ConcretingRequestType";
  /** The concrete batching plant of the concreting request */
  concreteBatchingPlant?: Maybe<ConcreteBatchingPlantType>;
  /** The contract of the concreting request */
  contract?: Maybe<ContractType>;
  /** The contract concrete recipe of the concreting request */
  contractConcreteRecipe?: Maybe<ContractConcreteRecipeType>;
  /** The contract pump type of the concreting request */
  contractPumpType?: Maybe<ContractPumpTypeType>;
  /** The creation date of the ConcretingRequest */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConcretingRequest */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConcretingRequest */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the ConcretingRequest */
  id: Scalars["ID"];
  /** The interval of the concreting request */
  interval: Scalars["String"];
  /** The messages of the concreting request */
  messages?: Maybe<Array<Maybe<ConcretingRequestMessageType>>>;
  /** The observation concreting of the concreting request */
  observationConcreting?: Maybe<Scalars["String"]>;
  /** The observation pump of the concreting request */
  observationPump?: Maybe<Scalars["String"]>;
  /** The piece to be concreted of the concreting request */
  pieceToBeConcreted?: Maybe<Scalars["String"]>;
  /** The piping distance of the concreting request */
  pipingDistance: Scalars["Decimal"];
  /** The pump of the concreting request */
  pump: EConcretingRequestPump | `${EConcretingRequestPump}`;
  /** The quantity per concrete mixer of the concreting request */
  quantityPerConcreteMixer: Scalars["Decimal"];
  /** The requested date of the concreting request */
  requestedDate: Scalars["DateTime"];
  /** The requested quantity of the concreting request */
  requestedQuantity: Scalars["Decimal"];
  /** The requester of the concreting request */
  requester: Scalars["String"];
  /** The requester phone number of the concreting request */
  requesterPhoneNumber: Scalars["String"];
  /** The requesting user of the concreting request */
  requestingUser?: Maybe<UserType>;
  /** The status of the concreting request */
  status: EConcretingRequestStatus | `${EConcretingRequestStatus}`;
  /** The to confirm of the concreting request */
  toConfirm: EConcretingRequestToConfirm | `${EConcretingRequestToConfirm}`;
  /** The travels released of the concreting request */
  travelsReleased?: Maybe<Scalars["Int"]>;
  /** The update date of the ConcretingRequest */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** ConcretingRequest Update Input */
export type ConcretingRequestUpdateInputType = {
  /** The concrete batching plant id of the concreting request */
  concreteBatchingPlantId?: InputMaybe<Scalars["ID"]>;
  /** The contract concrete recipe id of the concreting request */
  contractConcreteRecipeId: Scalars["ID"];
  /** The contract id of the concreting request */
  contractId: Scalars["ID"];
  /** The contract pump type id of the concreting request */
  contractPumpTypeId?: InputMaybe<Scalars["ID"]>;
  /** The id of the ConcretingRequest */
  id: Scalars["ID"];
  /** The interval of the concreting request */
  interval?: InputMaybe<Scalars["String"]>;
  /** The observation concreting of the concreting request */
  observationConcreting?: InputMaybe<Scalars["String"]>;
  /** The observation pump of the concreting request */
  observationPump?: InputMaybe<Scalars["String"]>;
  /** The piece to be concreted of the concreting request */
  pieceToBeConcreted?: InputMaybe<Scalars["String"]>;
  /** The piping distance of the pump of the concreting request */
  pipingDistance: Scalars["Decimal"];
  /** The pump of the concreting request */
  pump: EConcretingRequestPump | `${EConcretingRequestPump}`;
  /** The quantity per concrete mixer of the concreting request */
  quantityPerConcreteMixer: Scalars["Decimal"];
  /** The requested date of the concreting request */
  requestedDate: Scalars["DateTime"];
  /** The requested quantity of the concreting request */
  requestedQuantity: Scalars["Decimal"];
  /** The requester of the concreting request */
  requester: Scalars["String"];
  /** The requester phone number of the concreting request */
  requesterPhoneNumber: Scalars["String"];
  /** The status of the concreting request */
  status: EConcretingRequestStatus | `${EConcretingRequestStatus}`;
  /** The travels released of the concreting request */
  travelsReleased?: InputMaybe<Scalars["Int"]>;
};

export type ConcretingRequestUpdateStatusInputType = {
  /** The id of the concreting request */
  id: Scalars["ID"];
  /** The new status of the concreting request */
  status: EConcretingRequestStatus | `${EConcretingRequestStatus}`;
};

export type ConcretingType = {
  __typename?: "ConcretingType";
  /** The concreteBatchingPlant of the concreting */
  concreteBatchingPlant?: Maybe<ConcreteBatchingPlantType>;
  /** The concreteStrengthCertificates of the concreting */
  concreteStrengthCertificates?: Maybe<Array<Maybe<ConcreteStrengthCertificateType>>>;
  /** The contract of the concreting */
  contract?: Maybe<ContractType>;
  /** The contractConcreteRecipe of the concreting */
  contractConcreteRecipe?: Maybe<ContractConcreteRecipeType>;
  /** The creation date of the Concreting */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Concreting */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Concreting */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The delivered volume of the concreting */
  deliveredVolume?: Maybe<Scalars["Decimal"]>;
  /** The external id of the concreting */
  externalId: Scalars["String"];
  /** The id of the Concreting */
  id: Scalars["ID"];
  /** The pendency of the concreting */
  pendency?: Maybe<Scalars["String"]>;
  /** The programmed volume of the concreting */
  programmedVolume: Scalars["Decimal"];
  /** The scheduled date of the concreting */
  scheduledDate: Scalars["DateTime"];
  /** The status of the concreting */
  status: EConcretingStatus | `${EConcretingStatus}`;
  /** The travels of the concreting */
  travels?: Maybe<Array<Maybe<TravelType>>>;
  /** The update date of the Concreting */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ConstructionEmail */
export type ConstructionEmailQueries = {
  __typename?: "ConstructionEmailQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ConstructionEmail>;
  getByID?: Maybe<CommandResult_ConstructionEmail>;
};

/** Queries for ConstructionEmail */
export type ConstructionEmailQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ConstructionEmail */
export type ConstructionEmailQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConstructionEmailType = {
  __typename?: "ConstructionEmailType";
  /** The construction of construction email */
  construction?: Maybe<ConstructionType>;
  /** The construction id of the construction email */
  constructionId: Scalars["ID"];
  /** The creation date of the ConstructionEmail */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ConstructionEmail */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ConstructionEmail */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The name of the construction email */
  email: Scalars["String"];
  /** The id of the ConstructionEmail */
  id: Scalars["ID"];
  /** The update date of the ConstructionEmail */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for Construction */
export type ConstructionQueries = {
  __typename?: "ConstructionQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Construction>;
  getByID?: Maybe<CommandResult_Construction>;
};

/** Queries for Construction */
export type ConstructionQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Construction */
export type ConstructionQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ConstructionType = {
  __typename?: "ConstructionType";
  /** The address of the construction */
  address: Scalars["String"];
  /** The client of the construction */
  client?: Maybe<ClientType>;
  /** The complement of the construction */
  complement?: Maybe<Scalars["String"]>;
  /** The contracts of the construction */
  contracts?: Maybe<Array<Maybe<ContractType>>>;
  /** The country of the construction */
  country: Scalars["String"];
  /** The county of the construction */
  county?: Maybe<Scalars["String"]>;
  /** The creation date of the Construction */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Construction */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Construction */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The district of the construction */
  district: Scalars["String"];
  /** The emails of the construction */
  emails?: Maybe<Array<Maybe<ConstructionEmailType>>>;
  /** The external id of the construction */
  externalId: Scalars["String"];
  /** The id of the Construction */
  id: Scalars["ID"];
  /** The name of the construction */
  name: Scalars["String"];
  /** The number of the construction */
  number?: Maybe<Scalars["String"]>;
  /** The permissions users of the construction */
  permissionsUsers?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The uf of the construction */
  uf: Scalars["String"];
  /** The update date of the Construction */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The zip code of the construction */
  zipCode?: Maybe<Scalars["String"]>;
};

/** Queries for ContractConcreteBatchingPlant */
export type ContractConcreteBatchingPlantQueries = {
  __typename?: "ContractConcreteBatchingPlantQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ContractConcreteBatchingPlant>;
  getByID?: Maybe<CommandResult_ContractConcreteBatchingPlant>;
};

/** Queries for ContractConcreteBatchingPlant */
export type ContractConcreteBatchingPlantQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ContractConcreteBatchingPlant */
export type ContractConcreteBatchingPlantQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ContractConcreteBatchingPlantType = {
  __typename?: "ContractConcreteBatchingPlantType";
  /** The concrete batching plant of the contract concrete batching plant. */
  concreteBatchingPlant?: Maybe<ConcreteBatchingPlantType>;
  /** The contract of the contract concrete batching plant. */
  contract?: Maybe<ContractType>;
  /** The creation date of the ContractConcreteBatchingPlant */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ContractConcreteBatchingPlant */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ContractConcreteBatchingPlant */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the ContractConcreteBatchingPlant */
  id: Scalars["ID"];
  /** The priority of the contract concrete batching plant. */
  priority?: Maybe<Scalars["Int"]>;
  /** The update date of the ContractConcreteBatchingPlant */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ContractConcreteRecipe */
export type ContractConcreteRecipeQueries = {
  __typename?: "ContractConcreteRecipeQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ContractConcreteRecipe>;
  getByID?: Maybe<CommandResult_ContractConcreteRecipe>;
};

/** Queries for ContractConcreteRecipe */
export type ContractConcreteRecipeQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ContractConcreteRecipe */
export type ContractConcreteRecipeQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ContractConcreteRecipeType = {
  __typename?: "ContractConcreteRecipeType";
  /** The concreteRecipe of the contractConcreteRecipe */
  concreteRecipe?: Maybe<ConcreteRecipeType>;
  /** The contract of the contractConcreteRecipe */
  contract?: Maybe<ContractType>;
  /** The creation date of the ContractConcreteRecipe */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ContractConcreteRecipe */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ContractConcreteRecipe */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The delivered volume of the contractConcreteRecipe */
  deliveredVolume?: Maybe<Scalars["Decimal"]>;
  /** The external id of the contractConcreteRecipe */
  externalId: Scalars["String"];
  /** The id of the ContractConcreteRecipe */
  id: Scalars["ID"];
  /** The m3 value of the contractConcreteRecipe */
  m3Value: Scalars["Decimal"];
  /** The status of the contractConcreteRecipe */
  status: EContractConcreteRecipeStatus | `${EContractConcreteRecipeStatus}`;
  /** The total volume of the contractConcreteRecipe */
  totalVolume: Scalars["Decimal"];
  /** The update date of the ContractConcreteRecipe */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for ContractPumpType */
export type ContractPumpTypeQueries = {
  __typename?: "ContractPumpTypeQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ContractPumpType>;
  getByID?: Maybe<CommandResult_ContractPumpType>;
};

/** Queries for ContractPumpType */
export type ContractPumpTypeQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ContractPumpType */
export type ContractPumpTypeQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ContractPumpTypeType = {
  __typename?: "ContractPumpTypeType";
  /** The code of the contractPumpType */
  code: Scalars["String"];
  /** The contract of the contractPumpType */
  contract?: Maybe<ContractType>;
  /** The creation date of the ContractPumpType */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ContractPumpType */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ContractPumpType */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the contractPumpType */
  description: Scalars["String"];
  /** The external id of the contractPumpType */
  externalId: Scalars["String"];
  /** The id of the ContractPumpType */
  id: Scalars["ID"];
  /** The status of the contractPumpType */
  status: EContractPumpTypeStatus | `${EContractPumpTypeStatus}`;
  /** The update date of the ContractPumpType */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for Contract */
export type ContractQueries = {
  __typename?: "ContractQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Contract>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Contract>;
  getByID?: Maybe<CommandResult_Contract>;
};

/** Queries for Contract */
export type ContractQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Contract */
export type ContractQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Contract */
export type ContractQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

/** ContractSeller Create Input */
export type ContractSellerCreateInputType = {
  /** The contractId of the conctract seller */
  contractId: Scalars["ID"];
  /** The sellerId of the contract seller */
  sellerId: Scalars["ID"];
};

/** Mutations for ContractSeller */
export type ContractSellerMutations = {
  __typename?: "ContractSellerMutations";
  create?: Maybe<CommandResult_ContractSeller>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_ContractSeller>;
};

/** Mutations for ContractSeller */
export type ContractSellerMutationsCreateArgs = {
  contractSeller: ContractSellerCreateInputType;
};

/** Mutations for ContractSeller */
export type ContractSellerMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for ContractSeller */
export type ContractSellerMutationsUpdateArgs = {
  contractSeller: ContractSellerUpdateInputType;
};

/** Queries for ContractSeller */
export type ContractSellerQueries = {
  __typename?: "ContractSellerQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ContractSeller>;
  getByID?: Maybe<CommandResult_ContractSeller>;
};

/** Queries for ContractSeller */
export type ContractSellerQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ContractSeller */
export type ContractSellerQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ContractSellerType = {
  __typename?: "ContractSellerType";
  /** The contract of the contractSeller */
  contract?: Maybe<ContractType>;
  /** The creation date of the ContractSeller */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ContractSeller */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ContractSeller */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the ContractSeller */
  id: Scalars["ID"];
  /** The seller of the contractSeller */
  seller?: Maybe<SellerType>;
  /** The update date of the ContractSeller */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** ContractSeller Update Input */
export type ContractSellerUpdateInputType = {
  /** The contractId of the conctract seller */
  contractId: Scalars["ID"];
  /** The id of the ContractSeller */
  id: Scalars["ID"];
  /** The sellerId of the contract seller */
  sellerId: Scalars["ID"];
};

export type ContractType = {
  __typename?: "ContractType";
  /** The code of the contract */
  code: Scalars["String"];
  /** The concretings of the contract */
  concretings?: Maybe<Array<Maybe<ConcretingType>>>;
  /** The construction of the contract */
  construction?: Maybe<ConstructionType>;
  /** The contractConcreteRecipes of the contract */
  contractConcreteRecipes?: Maybe<Array<Maybe<ContractConcreteRecipeType>>>;
  /** The contract date of the contract */
  contractDate: Scalars["DateTime"];
  /** The contractPumpTypes of the contract */
  contractPumpTypes?: Maybe<Array<Maybe<ContractPumpTypeType>>>;
  /** The contractSellers of the contract */
  contractSellers?: Maybe<Array<Maybe<ContractSellerType>>>;
  /** The creation date of the Contract */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Contract */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Contract */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The external id of the contract */
  externalId: Scalars["String"];
  /** The id of the Contract */
  id: Scalars["ID"];
  /** The invoices of the contract */
  invoices?: Maybe<Array<Maybe<InvoiceType>>>;
  /** The pendency of the contract */
  pendency?: Maybe<Scalars["String"]>;
  /** The permissionsUsers of the contract */
  permissionsUsers?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The status of the contract */
  status: EContractStatus | `${EContractStatus}`;
  /** The update date of the Contract */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The value of the contract */
  showPrice?: Maybe<Scalars["Boolean"]>;
};

/** Queries for Driver */
export type DriverQueries = {
  __typename?: "DriverQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Driver>;
  getByID?: Maybe<CommandResult_Driver>;
};

/** Queries for Driver */
export type DriverQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Driver */
export type DriverQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type DriverType = {
  __typename?: "DriverType";
  /** The code of the driver */
  code?: Maybe<Scalars["String"]>;
  /** The creation date of the Driver */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Driver */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Driver */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The document of the driver */
  document?: Maybe<Scalars["String"]>;
  /** The external id of the driver */
  externalId: Scalars["String"];
  /** The id of the Driver */
  id: Scalars["ID"];
  /** The name of the driver */
  name: Scalars["String"];
  /** The update date of the Driver */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

export const enum ECommandResultStatus {
  ALERT = "ALERT",
  ERROR = "ERROR",
  SUCCESS = "SUCCESS"
}

export const enum EConcretingRequestPump {
  BOOM = "BOOM",
  NO_PUMP = "NO_PUMP",
  STATIONARY = "STATIONARY"
}

export const enum EConcretingRequestStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED",
  REQUESTED = "REQUESTED"
}

export const enum EConcretingRequestToConfirm {
  NO = "NO",
  PARTIAL = "PARTIAL",
  YES = "YES"
}

export const enum EConcretingStatus {
  CANCELED = "CANCELED",
  COMPLETED = "COMPLETED",
  IN_PROGRESS = "IN_PROGRESS",
  PROGRAMMED = "PROGRAMMED"
}

export const enum EContractConcreteRecipeStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export const enum EContractPumpTypeStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE"
}

export const enum EContractStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING"
}

export const enum EInvoiceStatus {
  OPEN = "OPEN",
  OVERDUE = "OVERDUE",
  PAID = "PAID"
}

export const enum EParameter {
  CLIENT_NAME = "CLIENT_NAME",
  GOOGLE = "GOOGLE",
  LOGIN_COLOR = "LOGIN_COLOR",
  PROG_SOLICITATION_MIN_DAYS = "PROG_SOLICITATION_MIN_DAYS",
  THEME = "THEME"
}

export const enum EPermissionUserStatus {
  APPROVED = "APPROVED",
  PENDING = "PENDING",
  REJECTED = "REJECTED"
}

export const enum ESlumpTypes {
  FLOW = "FLOW",
  TEST = "TEST"
}

export const enum ESort {
  ASC = "ASC",
  DESC = "DESC"
}

export const enum ETravelStatus {
  CANCELED = "CANCELED",
  DELIVERED = "DELIVERED",
  DISCHARGING = "DISCHARGING",
  INVOICE_ISSUED = "INVOICE_ISSUED",
  IN_CONSTRUCTION = "IN_CONSTRUCTION",
  IN_TRANSIT = "IN_TRANSIT",
  PREPARING = "PREPARING",
  PROGRAMMED = "PROGRAMMED"
}

export const enum EWhereClausesOperators {
  CONTAINS = "CONTAINS",
  EQUALS = "EQUALS",
  GREATER_THAN = "GREATER_THAN",
  GREATER_THAN_OR_EQUAL = "GREATER_THAN_OR_EQUAL",
  IN = "IN",
  LESS_THAN = "LESS_THAN",
  LESS_THAN_OR_EQUAL = "LESS_THAN_OR_EQUAL"
}

/** The result of a command (Enumerable) */
export type EnumerableCommandResult_Client = {
  __typename?: "EnumerableCommandResult_Client";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<Array<Maybe<ClientType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** The result of a command (Enumerable) */
export type EnumerableCommandResult_PermissionUser = {
  __typename?: "EnumerableCommandResult_PermissionUser";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The result of the command */
  result?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
};

/** Queries for FiscalDocument */
export type FiscalDocumentQueries = {
  __typename?: "FiscalDocumentQueries";
  getAllWithPagination?: Maybe<ListCommandResult_FiscalDocument>;
  getByID?: Maybe<CommandResult_FiscalDocument>;
};

/** Queries for FiscalDocument */
export type FiscalDocumentQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for FiscalDocument */
export type FiscalDocumentQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type FiscalDocumentType = {
  __typename?: "FiscalDocumentType";
  /** The archive of the fiscalDocument */
  archive?: Maybe<ArchiveType>;
  /** The creation date of the FiscalDocument */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the FiscalDocument */
  deleted: Scalars["Boolean"];
  /** The deletion date of the FiscalDocument */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The external id of the fiscalDocument */
  externalId: Scalars["String"];
  /** The fiscalDocumentNumber of the fiscalDocument */
  fiscalDocumentNumber: Scalars["String"];
  /** The id of the FiscalDocument */
  id: Scalars["ID"];
  /** The update date of the FiscalDocument */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for GravelType */
export type GravelTypeQueries = {
  __typename?: "GravelTypeQueries";
  getAllWithPagination?: Maybe<ListCommandResult_GravelType>;
  getByID?: Maybe<CommandResult_GravelType>;
};

/** Queries for GravelType */
export type GravelTypeQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for GravelType */
export type GravelTypeQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type GravelTypeType = {
  __typename?: "GravelTypeType";
  /** The abbreviation of the gravelType */
  abbreviation: Scalars["String"];
  /** The creation date of the GravelType */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the GravelType */
  deleted: Scalars["Boolean"];
  /** The deletion date of the GravelType */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the gravelType */
  description: Scalars["String"];
  /** The id of the GravelType */
  id: Scalars["ID"];
  /** The update date of the GravelType */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Queries for InvoiceInstallment */
export type InvoiceInstallmentQueries = {
  __typename?: "InvoiceInstallmentQueries";
  getAllWithPagination?: Maybe<ListCommandResult_InvoiceInstallment>;
  getByID?: Maybe<CommandResult_InvoiceInstallment>;
};

/** Queries for InvoiceInstallment */
export type InvoiceInstallmentQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for InvoiceInstallment */
export type InvoiceInstallmentQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type InvoiceInstallmentType = {
  __typename?: "InvoiceInstallmentType";
  /** The amountPaid of the invoiceInstallment */
  amountPaid?: Maybe<Scalars["Decimal"]>;
  /** The archive of the invoiceInstallment */
  archive?: Maybe<ArchiveType>;
  /** The billingMethod of the invoiceInstallment */
  billingMethod?: Maybe<Scalars["String"]>;
  /** The creation date of the InvoiceInstallment */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the InvoiceInstallment */
  deleted: Scalars["Boolean"];
  /** The deletion date of the InvoiceInstallment */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The dueDate of the invoiceInstallment */
  dueDate: Scalars["DateTime"];
  /** The external id of the invoiceInstallment */
  externalId: Scalars["String"];
  /** The id of the InvoiceInstallment */
  id: Scalars["ID"];
  /** The installmentNumber of the invoiceInstallment */
  installmentNumber: Scalars["Decimal"];
  /** The invoice of the invoiceInstallment */
  invoice?: Maybe<InvoiceType>;
  /** The netValue of the invoiceInstallment */
  netValue: Scalars["Decimal"];
  /** The settlementDate of the invoiceInstallment */
  settlementDate?: Maybe<Scalars["DateTime"]>;
  /** The status of the invoiceInstallment */
  status: EInvoiceStatus | `${EInvoiceStatus}`;
  /** The update date of the InvoiceInstallment */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The withholdings of the invoiceInstallment */
  withholdings?: Maybe<Scalars["Decimal"]>;
};

/** Queries for Invoice */
export type InvoiceQueries = {
  __typename?: "InvoiceQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Invoice>;
  getAllWithSortedPagination?: Maybe<ListCommandResult_Invoice>;
  getByID?: Maybe<CommandResult_Invoice>;
};

/** Queries for Invoice */
export type InvoiceQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Invoice */
export type InvoiceQueriesGetAllWithSortedPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  sort?: InputMaybe<Array<InputMaybe<SortClausesInputType>>>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Invoice */
export type InvoiceQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type InvoiceType = {
  __typename?: "InvoiceType";
  /** The archive of the invoice */
  archive?: Maybe<ArchiveType>;
  /** The contract of the invoice */
  contract?: Maybe<ContractType>;
  /** The creation date of the Invoice */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Invoice */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Invoice */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The external id of the invoice */
  externalId: Scalars["String"];
  /** The fiscalDocument of the invoice */
  fiscalDocument?: Maybe<FiscalDocumentType>;
  /** The id of the Invoice */
  id: Scalars["ID"];
  /** The invoiceInstallments of the invoice */
  invoiceInstallments?: Maybe<Array<Maybe<InvoiceInstallmentType>>>;
  /** The invoiceNumber of the invoice */
  invoiceNumber: Scalars["String"];
  /** The issueDate of the invoice */
  issueDate: Scalars["DateTime"];
  /** The status of the invoice */
  status: EInvoiceStatus | `${EInvoiceStatus}`;
  /** The update date of the Invoice */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Archive = {
  __typename?: "ListCommandResult_Archive";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ArchiveType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Client = {
  __typename?: "ListCommandResult_Client";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ClientType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcreteBatchingPlant = {
  __typename?: "ListCommandResult_ConcreteBatchingPlant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcreteBatchingPlantType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcreteMixer = {
  __typename?: "ListCommandResult_ConcreteMixer";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcreteMixerType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcreteRecipe = {
  __typename?: "ListCommandResult_ConcreteRecipe";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcreteRecipeType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcreteStrengthCertificate = {
  __typename?: "ListCommandResult_ConcreteStrengthCertificate";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcreteStrengthCertificateType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Concreting = {
  __typename?: "ListCommandResult_Concreting";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcretingType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcretingRequest = {
  __typename?: "ListCommandResult_ConcretingRequest";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcretingRequestType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConcretingRequestMessage = {
  __typename?: "ListCommandResult_ConcretingRequestMessage";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConcretingRequestMessageType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Construction = {
  __typename?: "ListCommandResult_Construction";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConstructionType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ConstructionEmail = {
  __typename?: "ListCommandResult_ConstructionEmail";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ConstructionEmailType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Contract = {
  __typename?: "ListCommandResult_Contract";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ContractType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ContractConcreteBatchingPlant = {
  __typename?: "ListCommandResult_ContractConcreteBatchingPlant";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ContractConcreteBatchingPlantType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ContractConcreteRecipe = {
  __typename?: "ListCommandResult_ContractConcreteRecipe";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ContractConcreteRecipeType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ContractPumpType = {
  __typename?: "ListCommandResult_ContractPumpType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ContractPumpTypeType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ContractSeller = {
  __typename?: "ListCommandResult_ContractSeller";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ContractSellerType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Driver = {
  __typename?: "ListCommandResult_Driver";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<DriverType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_FiscalDocument = {
  __typename?: "ListCommandResult_FiscalDocument";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<FiscalDocumentType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_GravelType = {
  __typename?: "ListCommandResult_GravelType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<GravelTypeType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Invoice = {
  __typename?: "ListCommandResult_Invoice";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<InvoiceType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_InvoiceInstallment = {
  __typename?: "ListCommandResult_InvoiceInstallment";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<InvoiceInstallmentType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Module = {
  __typename?: "ListCommandResult_Module";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ModuleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Param = {
  __typename?: "ListCommandResult_Param";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ParamType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_PermissionUser = {
  __typename?: "ListCommandResult_PermissionUser";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_ResistanceType = {
  __typename?: "ListCommandResult_ResistanceType";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<ResistanceTypeType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Seller = {
  __typename?: "ListCommandResult_Seller";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<SellerType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_SellerModule = {
  __typename?: "ListCommandResult_SellerModule";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<SellerModuleType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_Travel = {
  __typename?: "ListCommandResult_Travel";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<TravelType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** A list of items (GraphQL Type) */
export type ListCommandResult_User = {
  __typename?: "ListCommandResult_User";
  /** The error code of the command */
  errorCode?: Maybe<Scalars["String"]>;
  /** The message of the command */
  message: Scalars["String"];
  /** The notifications of the command */
  notifications?: Maybe<Array<Maybe<Notification>>>;
  /** The page of the command */
  page: Scalars["UInt"];
  /** The page count of the command */
  pageCount: Scalars["UInt"];
  /** The per page of the command */
  perPage: Scalars["UInt"];
  /** The result of the command */
  result?: Maybe<Array<Maybe<UserType>>>;
  /** The status of the command */
  status?: Maybe<ECommandResultStatus | `${ECommandResultStatus}`>;
  /** The total count of the command */
  totalCount: Scalars["ULong"];
};

/** Queries for Module */
export type ModuleQueries = {
  __typename?: "ModuleQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Module>;
  getByID?: Maybe<CommandResult_Module>;
};

/** Queries for Module */
export type ModuleQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Module */
export type ModuleQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ModuleType = {
  __typename?: "ModuleType";
  /** The creation date of the Module */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Module */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Module */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the module */
  description?: Maybe<Scalars["String"]>;
  /** The id of the Module */
  id: Scalars["ID"];
  /** The permissions users of the module */
  permissionsUsers?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The seller modules of the module */
  sellerModules?: Maybe<Array<Maybe<SellerModuleType>>>;
  /** The update date of the Module */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Mutations for the Topcon Customer GraphQL API */
export type Mutations = {
  __typename?: "Mutations";
  assets?: Maybe<AssetsMutation>;
  client?: Maybe<ClientMutations>;
  concretingRequest?: Maybe<ConcretingRequestMutations>;
  concretingRequestMessage?: Maybe<ConcretingRequestMessageMutations>;
  contractSeller?: Maybe<ContractSellerMutations>;
  param?: Maybe<ParamMutations>;
  permissionUser?: Maybe<PermissionUserMutations>;
  sellerModule?: Maybe<SellerModuleMutations>;
  user?: Maybe<UserMutations>;
};

/** Notification */
export type Notification = {
  __typename?: "Notification";
  /** The error code */
  errorCode: Scalars["String"];
  /** The error message */
  errorMessage: Scalars["String"];
  /** The property name */
  propertyName: Scalars["String"];
};

/** Mutations for Param */
export type ParamMutations = {
  __typename?: "ParamMutations";
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_Param>;
};

/** Mutations for Param */
export type ParamMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for Param */
export type ParamMutationsUpdateArgs = {
  param: ParamUpdateInputType;
};

/** Queries for Param */
export type ParamQueries = {
  __typename?: "ParamQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Param>;
  getByID?: Maybe<CommandResult_Param>;
  getLoginColor?: Maybe<CommandResult_Param>;
};

/** Queries for Param */
export type ParamQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Param */
export type ParamQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ParamType = {
  __typename?: "ParamType";
  /** The creation date of the Param */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Param */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Param */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the Param */
  id: Scalars["ID"];
  /** The key of the parameter */
  key: Scalars["String"];
  /** The name of the parameter */
  name: EParameter | `${EParameter}`;
  /** The update date of the Param */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** Param Update Input Type */
export type ParamUpdateInputType = {
  /** The id of the Param */
  id: Scalars["ID"];
  /** The key/value of param */
  key: Scalars["String"];
};

/** PermissionUser Create Input */
export type PermissionUserCreateInputType = {
  /** The constructionId of the permission user */
  constructionId: Scalars["ID"];
  /** The contractId of the permission user */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** The moduleId of the permission user */
  moduleId: Scalars["ID"];
  /** The statusChangeDate of the permission user */
  statusChangeDate?: InputMaybe<Scalars["DateTime"]>;
  /** The statusChangeUserId of the permission user */
  statusChangeUserId?: InputMaybe<Scalars["ID"]>;
  /** The userId of the permission user */
  userId: Scalars["ID"];
};

/** Mutations for PermissionUser */
export type PermissionUserMutations = {
  __typename?: "PermissionUserMutations";
  create?: Maybe<CommandResult_PermissionUser>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_PermissionUser>;
};

/** Mutations for PermissionUser */
export type PermissionUserMutationsCreateArgs = {
  permissionUser: PermissionUserCreateInputType;
};

/** Mutations for PermissionUser */
export type PermissionUserMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for PermissionUser */
export type PermissionUserMutationsUpdateArgs = {
  permissionUser: PermissionUserUpdateInputType;
};

/** Queries for PermissionUser */
export type PermissionUserQueries = {
  __typename?: "PermissionUserQueries";
  getAllWithPagination?: Maybe<ListCommandResult_PermissionUser>;
  getAllWithoutPagination?: Maybe<EnumerableCommandResult_PermissionUser>;
  getByID?: Maybe<CommandResult_PermissionUser>;
};

/** Queries for PermissionUser */
export type PermissionUserQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for PermissionUser */
export type PermissionUserQueriesGetAllWithoutPaginationArgs = {
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for PermissionUser */
export type PermissionUserQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type PermissionUserType = {
  __typename?: "PermissionUserType";
  /** The construction of the permissionUser */
  construction?: Maybe<ConstructionType>;
  /** The contract of the permissionUser */
  contract?: Maybe<ContractType>;
  /** The creation date of the PermissionUser */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the PermissionUser */
  deleted: Scalars["Boolean"];
  /** The deletion date of the PermissionUser */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the PermissionUser */
  id: Scalars["ID"];
  /** The module of the permissionUser */
  module?: Maybe<ModuleType>;
  /** The status of the permissionUser */
  status: EPermissionUserStatus | `${EPermissionUserStatus}`;
  /** The statusChangeDate of the permissionUser */
  statusChangeDate?: Maybe<Scalars["DateTime"]>;
  /** The userAdministrator of the permissionUser */
  statusChangeUser?: Maybe<UserType>;
  /** The update date of the PermissionUser */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The user of the permissionUser */
  user?: Maybe<UserType>;
};

/** PermissionUser Update Input */
export type PermissionUserUpdateInputType = {
  /** The constructionId of the permission user */
  constructionId: Scalars["ID"];
  /** The contractId of the permission user */
  contractId?: InputMaybe<Scalars["ID"]>;
  /** The id of the PermissionUser */
  id: Scalars["ID"];
  /** The moduleId of the permission user */
  moduleId: Scalars["ID"];
  /** The userId of the permission user */
  userId: Scalars["ID"];
};

/** Queries for the Topcon Customer GraphQL API */
export type Queries = {
  __typename?: "Queries";
  archive?: Maybe<ArchiveQueries>;
  client?: Maybe<ClientQueries>;
  concreteBatchingPlant?: Maybe<ConcreteBatchingPlantQueries>;
  concreteMixer?: Maybe<ConcreteMixerQueries>;
  concreteRecipe?: Maybe<ConcreteRecipeQueries>;
  concreteStrengthCertificate?: Maybe<ConcreteStrengthCertificateQueries>;
  concreting?: Maybe<ConcretingQueries>;
  concretingRequest?: Maybe<ConcretingRequestQueries>;
  concretingRequestMessage?: Maybe<ConcretingRequestMessageQueries>;
  construction?: Maybe<ConstructionQueries>;
  constructionEmail?: Maybe<ConstructionEmailQueries>;
  contract?: Maybe<ContractQueries>;
  contractConcreteBatchingPlant?: Maybe<ContractConcreteBatchingPlantQueries>;
  contractConcreteRecipe?: Maybe<ContractConcreteRecipeQueries>;
  contractPumpType?: Maybe<ContractPumpTypeQueries>;
  contractSeller?: Maybe<ContractSellerQueries>;
  driver?: Maybe<DriverQueries>;
  fiscalDocument?: Maybe<FiscalDocumentQueries>;
  gravelType?: Maybe<GravelTypeQueries>;
  invoice?: Maybe<InvoiceQueries>;
  invoiceInstallment?: Maybe<InvoiceInstallmentQueries>;
  module?: Maybe<ModuleQueries>;
  param?: Maybe<ParamQueries>;
  permissionUser?: Maybe<PermissionUserQueries>;
  resistanceType?: Maybe<ResistanceTypeQueries>;
  seller?: Maybe<SellerQueries>;
  sellerModule?: Maybe<SellerModuleQueries>;
  travel?: Maybe<TravelQueries>;
  user?: Maybe<UserQueries>;
};

/** Queries for ResistanceType */
export type ResistanceTypeQueries = {
  __typename?: "ResistanceTypeQueries";
  getAllWithPagination?: Maybe<ListCommandResult_ResistanceType>;
  getByID?: Maybe<CommandResult_ResistanceType>;
};

/** Queries for ResistanceType */
export type ResistanceTypeQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for ResistanceType */
export type ResistanceTypeQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type ResistanceTypeType = {
  __typename?: "ResistanceTypeType";
  /** The abbreviation of the gravelType */
  abbreviation: Scalars["String"];
  /** The creation date of the ResistanceType */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the ResistanceType */
  deleted: Scalars["Boolean"];
  /** The deletion date of the ResistanceType */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The description of the gravelType */
  description: Scalars["String"];
  /** The id of the ResistanceType */
  id: Scalars["ID"];
  /** The update date of the ResistanceType */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** SellerModule Create Input */
export type SellerModuleCreateInputType = {
  /** The moduleId of the seller module */
  moduleId: Scalars["ID"];
  /** The sellerId of the seller module */
  sellerId: Scalars["ID"];
};

/** Mutations for SellerModule */
export type SellerModuleMutations = {
  __typename?: "SellerModuleMutations";
  create?: Maybe<CommandResult_SellerModule>;
  delete?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_SellerModule>;
};

/** Mutations for SellerModule */
export type SellerModuleMutationsCreateArgs = {
  sellerModule: SellerModuleCreateInputType;
};

/** Mutations for SellerModule */
export type SellerModuleMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for SellerModule */
export type SellerModuleMutationsUpdateArgs = {
  sellerModule: SellerModuleUpdateInputType;
};

/** Queries for SellerModule */
export type SellerModuleQueries = {
  __typename?: "SellerModuleQueries";
  getAllWithPagination?: Maybe<ListCommandResult_SellerModule>;
  getByID?: Maybe<CommandResult_SellerModule>;
};

/** Queries for SellerModule */
export type SellerModuleQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for SellerModule */
export type SellerModuleQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type SellerModuleType = {
  __typename?: "SellerModuleType";
  /** The creation date of the SellerModule */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the SellerModule */
  deleted: Scalars["Boolean"];
  /** The deletion date of the SellerModule */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The id of the SellerModule */
  id: Scalars["ID"];
  /** The module of the sellerModule */
  module?: Maybe<ModuleType>;
  /** The seller of the sellerModule */
  seller?: Maybe<SellerType>;
  /** The update date of the SellerModule */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** SellerModule Update Input */
export type SellerModuleUpdateInputType = {
  /** The id of the SellerModule */
  id: Scalars["ID"];
  /** The moduleId of the seller module */
  moduleId: Scalars["ID"];
  /** The sellerId of the seller module */
  sellerId: Scalars["ID"];
};

/** Queries for Seller */
export type SellerQueries = {
  __typename?: "SellerQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Seller>;
  getByID?: Maybe<CommandResult_Seller>;
};

/** Queries for Seller */
export type SellerQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Seller */
export type SellerQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type SellerType = {
  __typename?: "SellerType";
  /** The contracts of the seller */
  contractSellers?: Maybe<Array<Maybe<ContractSellerType>>>;
  /** The creation date of the Seller */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Seller */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Seller */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The email of the seller */
  email: Scalars["String"];
  /** The external id of the seller */
  externalId: Scalars["String"];
  /** The id of the Seller */
  id: Scalars["ID"];
  /** The name of the seller */
  name: Scalars["String"];
  /** The phone number of the seller */
  phoneNumber?: Maybe<Scalars["String"]>;
  /** The modules of the seller */
  sellerModules?: Maybe<Array<Maybe<SellerModuleType>>>;
  /** The update date of the Seller */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The user of the seller */
  user?: Maybe<UserType>;
};

/** Sort input type */
export type SortClausesInputType = {
  /** The property to filter */
  field?: InputMaybe<Scalars["String"]>;
  /** The value to filter */
  sortDirection?: InputMaybe<ESort | `${ESort}`>;
};

/** Queries for Travel */
export type TravelQueries = {
  __typename?: "TravelQueries";
  getAllWithPagination?: Maybe<ListCommandResult_Travel>;
  getByID?: Maybe<CommandResult_Travel>;
  getPositionByExternalId?: Maybe<CommandResult_VehiclePosition>;
};

/** Queries for Travel */
export type TravelQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for Travel */
export type TravelQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

/** Queries for Travel */
export type TravelQueriesGetPositionByExternalIdArgs = {
  externalId: Scalars["String"];
};

export type TravelType = {
  __typename?: "TravelType";
  /** The concrete mixer of the travel */
  concreteMixer?: Maybe<ConcreteMixerType>;
  /** The concreting of the travel */
  concreting?: Maybe<ConcretingType>;
  /** The construction end time of the travel */
  constructionEndTime?: Maybe<Scalars["DateTime"]>;
  /** The construction start time of the travel */
  constructionStartTime?: Maybe<Scalars["DateTime"]>;
  /** The creation date of the Travel */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the Travel */
  deleted: Scalars["Boolean"];
  /** The deletion date of the Travel */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The discharge end time of the travel */
  dischargeEndTime?: Maybe<Scalars["DateTime"]>;
  /** The discharge start time of the travel */
  dischargeStartTime?: Maybe<Scalars["DateTime"]>;
  /** The document number of the travel */
  documentNumber?: Maybe<Scalars["String"]>;
  /** The driver of the travel */
  driver?: Maybe<DriverType>;
  /** The external id of the travel */
  externalId: Scalars["String"];
  /** The finish time of the travel */
  finishTime?: Maybe<Scalars["DateTime"]>;
  /** The external id used in the fleet */
  fleetExternalId?: Maybe<Scalars["String"]>;
  /** The id of the Travel */
  id: Scalars["ID"];
  /** The invoice issue time of the travel */
  invoiceIssueTime?: Maybe<Scalars["DateTime"]>;
  /** The load label of the travel */
  loadLabel?: Maybe<Scalars["String"]>;
  /** The plant departure time of the travel */
  plantDepartureTime?: Maybe<Scalars["DateTime"]>;
  /** The scheduled time of the travel */
  scheduledTime?: Maybe<Scalars["DateTime"]>;
  /** The status of the travel */
  status: ETravelStatus | `${ETravelStatus}`;
  /** The update date of the Travel */
  updatedAt?: Maybe<Scalars["DateTime"]>;
  /** The volume of the travel */
  volume: Scalars["Decimal"];
};

/** User Create Input */
export type UserCreateInputType = {
  /** The client name of the user */
  clientName: Scalars["String"];
  /** The document of the user */
  document?: InputMaybe<Scalars["String"]>;
  /** The email of the user */
  email: Scalars["String"];
  /** The full name of the user */
  fullName: Scalars["String"];
  /** The phone number of the user */
  phoneNumber?: InputMaybe<Scalars["String"]>;
  /** The role of the user */
  role?: InputMaybe<Scalars["String"]>;
};

export type UserDeleteInputType = {
  /** The email of the user */
  email: Scalars["String"];
  /** The password of the user */
  password: Scalars["String"];
};

export type UserEmailInputType = {
  email: Scalars["String"];
};

/** Mutations for User */
export type UserMutations = {
  __typename?: "UserMutations";
  create?: Maybe<CommandResult_User>;
  customDelete?: Maybe<CommandResult_Void>;
  delete?: Maybe<CommandResult_Void>;
  handleActiveUser?: Maybe<CommandResult_Void>;
  resendEmailConfirmation?: Maybe<CommandResult_Void>;
  update?: Maybe<CommandResult_User>;
  userEmail?: Maybe<CommandResult_Void>;
};

/** Mutations for User */
export type UserMutationsCreateArgs = {
  user: UserCreateInputType;
};

/** Mutations for User */
export type UserMutationsCustomDeleteArgs = {
  user: UserDeleteInputType;
};

/** Mutations for User */
export type UserMutationsDeleteArgs = {
  id: Scalars["Guid"];
  permanent?: InputMaybe<Scalars["Boolean"]>;
};

/** Mutations for User */
export type UserMutationsHandleActiveUserArgs = {
  user: UserUpdateInputType;
};

/** Mutations for User */
export type UserMutationsResendEmailConfirmationArgs = {
  user: UserEmailInputType;
};

/** Mutations for User */
export type UserMutationsUpdateArgs = {
  user: UserUpdateInputType;
};

/** Mutations for User */
export type UserMutationsUserEmailArgs = {
  user: UserEmailInputType;
};

/** Queries for User */
export type UserQueries = {
  __typename?: "UserQueries";
  getAllWithPagination?: Maybe<ListCommandResult_User>;
  getByID?: Maybe<CommandResult_User>;
};

/** Queries for User */
export type UserQueriesGetAllWithPaginationArgs = {
  caseSensitive?: InputMaybe<Scalars["Boolean"]>;
  includeDeleted?: InputMaybe<Scalars["Boolean"]>;
  page?: InputMaybe<Scalars["Int"]>;
  perPage?: InputMaybe<Scalars["Int"]>;
  where?: InputMaybe<Array<InputMaybe<WhereClausesInputType>>>;
};

/** Queries for User */
export type UserQueriesGetByIdArgs = {
  id: Scalars["Guid"];
};

export type UserType = {
  __typename?: "UserType";
  /** If the user is active */
  active: Scalars["Boolean"];
  /** The client name of the user */
  clientName?: Maybe<Scalars["String"]>;
  /** The creation date of the User */
  createdAt: Scalars["DateTime"];
  /** The deleted status of the User */
  deleted: Scalars["Boolean"];
  /** The deletion date of the User */
  deletedAt?: Maybe<Scalars["DateTime"]>;
  /** The document of the user */
  document?: Maybe<Scalars["String"]>;
  /** The email of the user */
  email: Scalars["String"];
  /** The full name of the user */
  fullName: Scalars["String"];
  /** The id of the User */
  id: Scalars["ID"];
  /** The validation status of the user */
  isValidated: Scalars["Boolean"];
  /** The permissions of the user */
  permissions?: Maybe<Array<Maybe<PermissionUserType>>>;
  /** The phone number of the user */
  phoneNumber?: Maybe<Scalars["String"]>;
  /** The role of the user */
  role?: Maybe<Scalars["String"]>;
  /** The token of the user */
  token?: Maybe<Scalars["String"]>;
  /** The update date of the User */
  updatedAt?: Maybe<Scalars["DateTime"]>;
};

/** User Update Input */
export type UserUpdateInputType = {
  /** If the user is active */
  active?: InputMaybe<Scalars["Boolean"]>;
  /** The client name of the user */
  clientName?: InputMaybe<Scalars["String"]>;
  /** The document of the user */
  document?: InputMaybe<Scalars["String"]>;
  /** The email of the user */
  email?: InputMaybe<Scalars["String"]>;
  /** The full name of the user */
  fullName?: InputMaybe<Scalars["String"]>;
  /** The id of the User */
  id: Scalars["ID"];
  /** The validation status of the user */
  isValidated?: InputMaybe<Scalars["Boolean"]>;
  /** The password of the user */
  password?: InputMaybe<Scalars["String"]>;
  /** The password confirmation of the user */
  passwordConfirmation?: InputMaybe<Scalars["String"]>;
  /** The phone number of the user */
  phoneNumber?: InputMaybe<Scalars["String"]>;
};

export type VehiclePositionType = {
  __typename?: "VehiclePositionType";
  /** The last latitude from vehicle */
  lastLatitude?: Maybe<Scalars["String"]>;
  /** The last longitude from vehicle */
  lastLongitude?: Maybe<Scalars["String"]>;
  /** The last send date of vehicle */
  lastSendDate?: Maybe<Scalars["String"]>;
};

/** Where clauses input type */
export type WhereClausesInputType = {
  /** The operator to filter */
  operator?: InputMaybe<EWhereClausesOperators | `${EWhereClausesOperators}`>;
  /** The property to filter */
  property?: InputMaybe<Scalars["String"]>;
  /** The value to filter */
  value?: InputMaybe<Scalars["String"]>;
};
